import {
  ALLOWED_COUNTRIES,
  DEVICES,
  UKRAINIAN_CITIES,
  UKRAINIAN_REGIONS,
} from "@adlywise/shared-data";
import { PLATFORM_FILTER_OPTIONS } from "@/features/devices/utils";
import type { ChoiceOption } from "./types";

export const DRAWER_TRANSITION_MS = 220;

export const COUNTRY_OPTIONS: ChoiceOption<string>[] = Array.from(
  ALLOWED_COUNTRIES.entries(),
)
  .map(([code, name]) => ({
    value: code,
    label: name,
  }))
  .sort((left, right) => left.label.localeCompare(right.label));

export const PLATFORM_OPTIONS: ChoiceOption<string>[] = PLATFORM_FILTER_OPTIONS;

export const DEVICE_OPTIONS: ChoiceOption<number>[] = Array.from(
  DEVICES.entries(),
)
  .map(([label, value]) => ({
    value,
    label,
  }))
  .sort((left, right) => left.label.localeCompare(right.label));

export const REGION_OPTIONS: ChoiceOption<string>[] = Array.from(
  UKRAINIAN_REGIONS.keys(),
)
  .sort((left, right) => left.localeCompare(right))
  .map((region) => ({
    value: region,
    label: region,
  }));

export const CITY_OPTIONS: ChoiceOption<string>[] = Array.from(
  UKRAINIAN_CITIES.keys(),
)
  .sort((left, right) => left.localeCompare(right))
  .map((city) => ({
    value: city,
    label: city,
  }));

export const KIND_OPTIONS: ChoiceOption<number>[] = [
  { value: 0, label: "Dynamic" },
  { value: 1, label: "Overlay" },
  { value: 2, label: "Banner" },
  { value: 3, label: "Static" },
];
